import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { AlertService } from 'ngx-alerts';
import {
	Client, RespuestaOptionDto, EstablecimientoOptionDto, PagedResultOfFormularioExtendedDto, FormularioExtendedDto
} from '../services/client';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { errorMessages } from '../../../../src/assets/constants.json';

@Component({
	selector: 'app-filters',
	templateUrl: './filters.component.html',
	styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
	establecimientoOpciones: EstablecimientoOptionDto;
	opciones: RespuestaOptionDto;
	gerenciasAreaSalud: any = [];
	municipios: any = [];
	provincia: any = {};
	private formularios: FormularioExtendedDto[] = [];
	preguntas: any = [];

	selectedEstablecimiento: any;
	selectedNivelAtencion: any;
	selectedRegionSalud: any;
	selectedProvincia: any;
	selectedMunicipio: any;
	selectedPreguntaId: any;
	selectedMonth: any;
	selectedYear: any;
	selectedFormularioId: any;
	selectedFechaDesde: any;
	selectedFechaHasta: any;
	selectedTipoServicio: any;
	selectedTipoSolicitud: any;
	selectedCasoResuelto: any;
	selectedUsuarioId: string;
	enableCasoResuelto = false;

	establecimientosForm: FormGroup;

	currentYear = new Date().getFullYear();
	availableYears = [];
	availableMonths: any[] = [
		{ titulo: 'Enero', valor: 0 },
		{ titulo: 'Febrero', valor: 1 },
		{ titulo: 'Marzo', valor: 2 },
		{ titulo: 'Abril', valor: 3 },
		{ titulo: 'Mayo', valor: 4 },
		{ titulo: 'Junio', valor: 5 },
		{ titulo: 'Julio', valor: 6 },
		{ titulo: 'Agosto', valor: 7 },
		{ titulo: 'Septiembre', valor: 8 },
		{ titulo: 'Octubre', valor: 9 },
		{ titulo: 'Noviembre', valor: 10 },
		{ titulo: 'Diciembre', valor: 11 }
	];

	@Input() enableTipoSolicitud = false;
	@Input() enableTipoServicio = false;
	@Input() enableUsuario = false;
	@Input() enableEstablecimiento = true;
	@Input() enableNivelAtencion = true;
	@Input() enableRegionSalud = true;
	@Input() enableProvincia = true;
	@Input() enableMunicipio = true;
	@Input() enableFechaDesde = true;
	@Input() enableFechaHasta = true;
	@Input() enableFormulario = true;
	@Input() enablePregunta = false;
	@Input() enableMonth = true;
	@Input() enableYear = true;
	@Input() enableSearchButton = true;
	@Input() enableExportButton = false;
	@Output() buscar: EventEmitter<any> = new EventEmitter<any>();

	constructor(
		public route: ActivatedRoute,
		public client: Client,
		private alertService: AlertService,
		private fb: FormBuilder
	) {
		this.selectedYear = this.currentYear;
		const startingYear = 2019;
		for (let year = startingYear; year <= this.currentYear; year++) {
			this.availableYears.push(year);
		}

		this.client.respuestas_GetRespuestaOptions(undefined)
			.subscribe((data: RespuestaOptionDto) => {
				this.opciones = data;
			}, (error) => {
				const errorMessage = error.status === 0 ?
					errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
				this.alertService.danger(errorMessage);
			});
	}

	ngOnInit() {
		const sub = this.route.queryParamMap
			.subscribe(params => {
				if (!!sub) {
					sub.unsubscribe();
					return;
				}
				const establecimientoId = params.get('establecimientoId') || undefined;
				const nombreEstablecimiento = params.get('nombreEstablecimiento') || undefined;
				if (!!establecimientoId && !!nombreEstablecimiento) {
					this.selectedEstablecimiento = { id: establecimientoId, name: nombreEstablecimiento };
				}
				this.selectedFormularioId = params.get('formularioId') || undefined;
			});

		if (this.enablePregunta) {
			this.client.formularios_GetFormularios(1, 9999, undefined, undefined)
				.subscribe((data: PagedResultOfFormularioExtendedDto) => {
					this.formularios = data.results;
				}, (error) => {
					const errorMessage = error.status === 0 ?
						errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
					this.alertService.danger(errorMessage);
				});
		}
		this.establecimientosForm = this.fb.group({
			nombreEstablecimiento: ['', [Validators.required, Validators.maxLength(100)]],
			nivelAtencion: ['', [Validators.required, Validators.maxLength(100)]],
			complejidadServicio: ['', [Validators.required, Validators.maxLength(100)]],
			tipoCentro: ['', [Validators.required, Validators.maxLength(100)]],
			administradoPor: ['', [Validators.required, Validators.maxLength(100)]],
			regionSalud: ['', [Validators.required, Validators.maxLength(100)]],
			gerenciaAreaSalud: ['', [Validators.required, Validators.maxLength(100)]],
			provincia: [{}, Validators.maxLength(100)],
			municipio: ['', [Validators.required, Validators.maxLength(100)]],
			metaMensual: [0]
		});
	}

	_export() {
		this.alertService.info('Los datos solicitados se descargaran en breve.');
		const tituloFormulario = this.opciones.formulario.find(x => x.id === parseInt(this.selectedFormularioId, 10)).name;
		this.client.formularios_ExportFormulario(
			this.selectedFormularioId,
			tituloFormulario,
			!!this.selectedFechaDesde
				? this.selectedFechaDesde.year + '-' +
				this.selectedFechaDesde.month.toString().padStart(2, '0') + '-' +
				this.selectedFechaDesde.day.toString().padStart(2, '0') +
				'T00:00:00'
				: undefined,
			!!this.selectedFechaHasta
				? this.selectedFechaHasta.year + '-' +
				this.selectedFechaHasta.month.toString().padStart(2, '0') + '-' +
				this.selectedFechaHasta.day.toString().padStart(2, '0') +
				'T23:59:59'
				: undefined,
			!!this.selectedNivelAtencion ? this.selectedNivelAtencion : undefined,
			!!this.selectedProvincia ? this.selectedProvincia : undefined,
			!!this.selectedMunicipio ? this.selectedMunicipio : undefined,
			!!this.selectedEstablecimiento ? this.selectedEstablecimiento.id : undefined,
			!!this.selectedTipoServicio ? this.selectedTipoServicio : undefined,
			!!this.selectedTipoSolicitud ? this.selectedTipoSolicitud : undefined,
			!!this.selectedRegionSalud ? this.selectedRegionSalud : undefined,
			!!this.selectedUsuarioId ? this.selectedUsuarioId : undefined
		)
			.subscribe(() => { });
	}

	onSelectFormulario() {
		const selectedFormularioId = parseInt(this.selectedFormularioId, 10);
		const selectedFormulario = this.opciones.formulario.find(x => x.id === selectedFormularioId);
		this.selectedTipoServicio = null;
		this.selectedTipoSolicitud = null;
		this.selectedCasoResuelto = null;
		if (!selectedFormulario) {
			this.enableCasoResuelto = false;
			this.enableTipoSolicitud = false;
			this.enableTipoServicio = false;
			return;
		}
		this.enableCasoResuelto = selectedFormulario.showCasoResuelto;
		this.enableTipoSolicitud = selectedFormulario.showTipoSolicitud;
		this.enableTipoServicio = selectedFormulario.showTipoServicio;
		if (this.enablePregunta) {
			const formulario = this.formularios.find(x => x.id === selectedFormularioId);
			this.preguntas = !!formulario ? formulario.preguntas : [];
		}
	}

	_buscar() {
		this.buscar.emit({
			usuarioId: !!this.selectedUsuarioId ? this.selectedUsuarioId : undefined,
			establecimientoId: !!this.selectedEstablecimiento ? this.selectedEstablecimiento.id : undefined,
			casoResuelto: this.enableCasoResuelto ? this.selectedCasoResuelto : undefined,
			nombreEstablecimiento: !!this.selectedEstablecimiento ? this.selectedEstablecimiento.name : undefined,
			tipoServicio: !!this.selectedTipoServicio && this.enableTipoServicio ? this.selectedTipoServicio : undefined,
			tipoSolicitud: !!this.selectedTipoSolicitud && this.enableTipoSolicitud ? this.selectedTipoSolicitud : undefined,
			nivelAtencion: !!this.selectedNivelAtencion ? this.selectedNivelAtencion : undefined,
			regionSalud: !!this.selectedRegionSalud ? this.selectedRegionSalud : undefined,
			provincia: !!this.selectedProvincia ? this.selectedProvincia : undefined,
			pregunta: !!this.selectedPreguntaId ? this.selectedPreguntaId : undefined,
			formularioId: !!this.selectedFormularioId ? this.selectedFormularioId : undefined,
			year: !!this.selectedYear ? this.selectedYear : undefined,
			month: !!this.selectedMonth ? parseInt(this.selectedMonth, 10) + 1 : undefined,
			fecha: (!!this.selectedFechaDesde || !!this.selectedFechaHasta) ?
				[
					!!this.selectedFechaDesde ?
						this.selectedFechaDesde.year + '-' +
						this.selectedFechaDesde.month.toString().padStart(2, '0') + '-' +
						this.selectedFechaDesde.day.toString().padStart(2, '0') +
						'T00:00:00'
						: undefined,
					!!this.selectedFechaHasta ?
						this.selectedFechaHasta.year + '-' +
						this.selectedFechaHasta.month.toString().padStart(2, '0') + '-' +
						this.selectedFechaHasta.day.toString().padStart(2, '0') +
						'T23:59:59'
						: undefined
				] : undefined
		});
	}
}
